import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';
import WYSIWYG from '../../../../components/WYSIWYG';
import VideoUrlInput from '../../../../components/VideoUrlInput';
import { mediaTypes } from '../../../../components/MediaCarousel/constants';
import { isValidVideoURL } from '../../../../utils/url';

import messages from '../../messages';
import './styles.css';

export class EditVideoComponent extends React.PureComponent {
  static propTypes = {
    selectedIndex: PropTypes.number,
    media: PropTypes.array,
    goBackVideo: PropTypes.func,
    onNext: PropTypes.func,
    initialValues: PropTypes.object,
  };

  state = {
    isDataValid: true,
    hasChanges: false,
    changes: undefined,
  };

  componentDidMount() {
    const { initialValues } = this.props;
    const mediaDisplayUrl = get(initialValues, 'mediaDisplayUrl');

    if (mediaDisplayUrl && ![mediaTypes.VIDEO_URL, mediaTypes.VIDEO_S3].includes(initialValues.media_type)) {
      this.setState({
        hasChanges: true,
        changes: {
          ...initialValues,
          mediaDisplayUrl: '',
        },
        isDataValid: false,
      });
    }
  }

  hasNewChanges = (url, caption) => {
    const { initialValues } = this.props;

    return initialValues ? (
      get(initialValues, 'mediaDisplayUrl') !== url ||
      get(initialValues, 'caption') !== caption
    ) : true;
  };

  onChangeUrl = (event, input) => {
    const { selectedIndex } = this.props;
    const hasStateChanges = this.state.hasChanges;
    const caption = get(this.state, 'changes.caption') || get(this.props, `media[${selectedIndex}].caption`);
    const hasChanges = hasStateChanges || this.hasNewChanges(input.value, caption);
    const changes = hasChanges ? this.state.changes : this.props.media[selectedIndex];

    this.setState({
      hasChanges,
      changes: {
        ...changes,
        mediaDisplayUrl: input.value,
      },
      isDataValid: isValidVideoURL(input.value),
    });
  };

  onChangeCaption = (caption, isCaptionValid) => {
    const { selectedIndex } = this.props;
    const hasStateChanges = this.state.hasChanges;
    const mediaDisplayUrl =
      /* eslint-disable-next-line react/no-access-state-in-setstate */
      get(this.state, 'changes.mediaDisplayUrl') || get(this.props, `media[${selectedIndex}].mediaDisplayUrl`);
    const hasChanges = hasStateChanges || this.hasNewChanges(mediaDisplayUrl, caption);
    const changes = hasChanges ? this.state.changes : this.props.media[selectedIndex];
    if (isCaptionValid === undefined) isCaptionValid = true;

    this.setState({
      hasChanges,
      changes: {
        ...changes,
        caption,
        mediaDisplayUrl,
      },
      isDataValid: isCaptionValid && isValidVideoURL(mediaDisplayUrl),
    });
  };

  render() {
    const { media, goBackVideo, onNext, selectedIndex } = this.props;
    const { isDataValid, hasChanges, changes } = this.state;
    const data = { ...get(media, selectedIndex, {}), ...changes };
    const { mediaDisplayUrl, caption } = data;

    return (
      <React.Fragment>
        <Modal.Content styleName="videos-modal-content">
          <div styleName="videos-instructions">
            <h2 styleName="edit-video-title"><FormattedMessage {...messages.addOrEditVideo} /></h2>
            <div styleName="edit-video-input">
              <FormattedMessage {...messages.addOrEditVideoLabel} />  &nbsp;
              <VideoUrlInput
                value={mediaDisplayUrl}
                onChange={this.onChangeUrl}
              />
            </div>
            <h3 styleName="edit-video-subtitle"><FormattedMessage {...messages.addOrEditVideoCaption} /></h3>
            <WYSIWYG
              limit={280}
              value={caption}
              mode="normal"
              onChange={this.onChangeCaption}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={goBackVideo}>
            <FormattedMessage {...messages.back} />
          </Button>
          <Button primary disabled={!isDataValid || !hasChanges} onClick={() => onNext(data)}>
            <FormattedMessage {...messages.next} />
          </Button>
        </Modal.Actions>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  media: get(state, 'nonPersistedCollegeProfile.media.media'),
});

export default connect(mapStateToProps, {})(EditVideoComponent);
